import React, { useState } from "react";
import { AutoRotatingCarousel, Slide } from "material-auto-rotating-carousel";

const AutoRotatingCarouselModal = ({
  handleOpen,
  setHandleOpen,
  isMobile,
  img,
  handleClose
}) => {
  const getSlideData = img => {
    return img.map(item => {
      if (item.path_url) {
        return (
          <Slide
            key={item.path_url}
            media={<img src={item.path_url} style={{ height: '100%', objectFit: 'contain', width: '100%' }} />}
            title=""
            subtitle=""
            mediaBackgroundStyle={{
              backgroundColor: "#000125",
              height: "100%",
              overflow: "hidden"
            }}
            style={{ overflow: "hidden" }}
          />
        );
      }
    });
  };

  return (
    <div>
      <AutoRotatingCarousel
        label={"Close"}
        open={handleOpen.open}
        onClose={() => setHandleOpen({ open: false })}
        onStart={() => setHandleOpen({ open: false })}
        autoplay={false}
        mobile={isMobile}
      >
        {getSlideData(img)}
      </AutoRotatingCarousel>
    </div>
  );
};

export default AutoRotatingCarouselModal;
